import React, { useEffect, useState } from 'react';
import {
    Routes,
    Route,
    useLocation
} from "react-router-dom";

import SubAdminUsers from './SubAdminUser.js';
import SubAdminSiteInfo from './SubAdminSiteInfo.js';
import SubAdminAppUpdate from './SubAdminAppUpdate.js';
import SubAdminInverterAlarm from './SubAdminInverterAlarm.js';
import SubAdminDocument from './SubAdminDocument.js';
import SubAdminDownloadCenter from './SubAdminDownloadCenter.js';
import SubAdminWakeUp from './SubAdminWakeUp.js';
import SubAdminBill from './SubAdminBill.js';
import SubAdminMeter5m from './SubAdminMeter5m.js';
import SubAdminMeterReverse from './SubAdminMeterReverse.js';

import Minibar from '../../../components/navbar/Minibar';

function MainAdmin(props) {
    const location = useLocation();
    const [submenu_root, setSubmenu_root] = useState('');

    useEffect(() => {
        if (location.pathname.search("/users") > -1) {
            setSubmenu_root('Users Authentication')
        }
        if (location.pathname.search("/sites") > -1) {
            setSubmenu_root('Sites Info')
        }
        if (location.pathname.search("/inverteralarm") > -1) {
            setSubmenu_root('Inverter Alarm')
        }
        if (location.pathname.search("/document") > -1) {
            setSubmenu_root('Project Document')
        }
        if (location.pathname.search("/appupdate") > -1) {
            setSubmenu_root('App Update')
        }
        if (location.pathname.search("/downloadcenter") > -1) {
            setSubmenu_root('Download Center')
        }
        if (location.pathname.search("/wakeup") > -1) {
            setSubmenu_root('PC Wake On LAN')
        }
        if (location.pathname.search("/refbill") > -1) {
            setSubmenu_root('Bill parameter')
        }
        if (location.pathname.search("/meter5m") > -1) {
            setSubmenu_root('Meter Calculation 5 Minutes')
        }
        if (location.pathname.search("/meterreverse") > -1) {
            setSubmenu_root('Meter Reverse')
        }
    }, [location]);

    return (
        <section id="content" className="content">
            <Minibar
                main_root={"Administrative Tool"}
                submenu_root={submenu_root}
                systemtime={props.data_systemdatetime}
            />
            <div className="content__boxed d-md-flex h-100">
                <div className="content__wrap order-2 flex-fill min-w-0 hi-100 border-left">
                    <Routes>
                        <Route path="/users" element={<SubAdminUsers permitdata={props.permitdata} />} />
                        <Route path="/sites" element={<SubAdminSiteInfo permitdata={props.permitdata} />} />
                        <Route path="/inverteralarm" element={<SubAdminInverterAlarm permitdata={props.permitdata} />} />
                        <Route path="/document" element={<SubAdminDocument permitdata={props.permitdata} />} />
                        <Route path="/wakeup" element={<SubAdminWakeUp permitdata={props.permitdata} />} />
                        <Route path="/downloadcenter" element={<SubAdminDownloadCenter permitdata={props.permitdata} />} />
                        <Route path="/appupdate" element={<SubAdminAppUpdate permitdata={props.permitdata} />} />
                        <Route path="/refbill" element={<SubAdminBill permitdata={props.permitdata} />} />
                        <Route path="/meter5m" element={<SubAdminMeter5m permitdata={props.permitdata} />} />
                        <Route path="/meterreverse" element={<SubAdminMeterReverse permitdata={props.permitdata} />} />
                    </Routes>
                </div>
            </div>
        </section>

    )
}
export default MainAdmin